import React from 'react'
import { isTestEnvironment } from '@utils/environment'
import { noop } from 'lodash'

type ImageProps = {
  src?: string
  // TODO: Alt should be a required property, but this requires some change
  // on the backend as we can't compute the alt text on backend every time for performance reasons
  alt?: string
  width?: string | number
  height?: string | number
  className?: string
  style?: React.CSSProperties
  loading?: 'lazy' | 'eager' | null // Note: Pass null or 'eager' to disable lazy loading
  onClick?: (e: React.MouseEvent<HTMLDivElement>) => void
  testId?: string
  role?: string
  tabIndex?: number
  'aria-label'?: string
  onKeyDown?: (e: React.KeyboardEvent<HTMLImageElement>) => void
}

const Image: React.FC<ImageProps> = ({
  src,
  alt,
  width,
  height,
  className,
  style,
  loading = 'lazy',
  onClick = noop,
  testId,
  role,
  tabIndex,
  'aria-label': ariaLabel,
  onKeyDown = noop,
}) => {
  if (!src) return null
  return (
    <img
      src={src}
      alt={alt}
      width={width}
      height={height}
      className={className}
      style={style}
      {...(loading !== null ? { loading } : {})} // Explicitly check for null
      onClick={onClick}
      onKeyDown={onKeyDown}
      role={role}
      tabIndex={tabIndex}
      aria-label={ariaLabel}
      {...(isTestEnvironment && testId ? { 'data-testid': testId } : {})}
    />
  )
}

export default Image
